<template>
    <el-select v-model="selected" @change="onChange" clearable filterable>
        <el-option :key="i" :label="option[labelKey]" :value="option[valueKey]" v-for="(option, i) in optionArr"></el-option>
    </el-select>
</template>

<script>
    export default {
        name: "RemoteSelect",
        props: ["url", "options", "value", "labelName", "valueName"],
        data() {
            return {
                optionArr: this.options,
                selected: this.value
            }
        },
        watch: {
            value(val) {
                this.selected = val;
            },
            options(val) {
                this.optionArr = val;
            }
        },
        computed: {
            labelKey() {
                if (this.labelName) {
                    return this.labelName;
                } else if (this.url && this.url.indexOf("/dict") === 0) {
                    return "text";
                } else {
                    return "label";
                }
            },
            valueKey() {
                return this.valueName ? this.valueName : "value";
            }
        },
        mounted() {
            if (this.url) {
                this.$axios.get(this.url).then(response => {
                    this.optionArr = response;
                })
            }
        },
        methods: {
            onChange(val) {
                this.$emit('input', val);
                this.$emit('change', val);
            }
        }
    }
</script>